import { signal } from '@angular/core';

import { IServerSideGetRowsParams } from 'ag-grid-enterprise';

export class CamGridCursor {
  private _requestParams: IServerSideGetRowsParams | null = null;
  private readonly _currentRowIndex = signal(0);
  private readonly _currentId = signal('');

  public readonly currentRowIndex = this._currentRowIndex.asReadonly();
  public readonly currentId = this._currentId.asReadonly();

  public getRequestParams() {
    return this._requestParams;
  }
  public setRequestParams(params: IServerSideGetRowsParams) {
    this._requestParams = { ...params, request: JSON.parse(JSON.stringify(params.request)) };
  }

  public setCurrent(index: number, id: string) {
    this._currentId.set(id);
    this._currentRowIndex.set(index);
  }
  public next(id: string) {
    this._currentRowIndex.update(index => index + 1);
    this._currentId.set(id);
  }
  public previous(id: string) {
    this._currentRowIndex.update(index => index - 1);
    this._currentId.set(id);
  }
}
